<template>
  <div class="unavailable-message" v-bind:class="{ active: !$store.state.socket.isConnected }">
    <img class="icon" src="@/assets/images/RU/unavailable-icon.png" alt="" />
    <p class="title">Нет соединения</p>
    <p class="description">Потеряна связь с сервером</p>
  </div>
</template>

<script>

export default {
  name: 'Status',
};
</script>

<style scoped>
.unavailable-message {
  top: 110%;
  left: 30%;
  bottom: 0;
  position: absolute;
  width: 40%;
  align-items: center;
  justify-content: center;
  opacity: 0;
  padding: 8px;

  font-family: 'ONY One',serif;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;

}
.active {
  opacity: 1;
}
.icon {
  width: 300px;
}
.title {
  font-size: 40px;
  color: rgba(255, 255, 255, 1);
  margin: 8px;
  font-weight: 500;
}
.description {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 400;
}
</style>
